module.exports = __webpack_public_path__ + "img/left_9_hover.87af578b.png";